import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";// import function
import axios from "axios";
import logo from "../src/Logo.png";
import { AUTH_API_BASE } from "./config/api";

export default function ItemTableViewer({ currentUser }) {
    const [selectedDate, setSelectedDate] = useState(
  new Date().toISOString().split("T")[0]
);
  const [items, setItems] = useState([]);
  const API_BASE = AUTH_API_BASE;
  const fetchItems = async () => {
    try {
      const res = await axios.get(`${API_BASE}/itempricing`);
      setItems(res.data || []);
    } catch (err) {
      console.error("Error fetching items:", err);
      setItems([]);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);


const downloadExcel = () => {
  if (!items || items.length === 0) {
    alert("No data available to download");
    return;
  }

  const excelData = items.map((item, index) => ({
    "S.No": index + 1,
    "Item Name": item.ItemName || "",
    "Unit": item.Unit || "",
    "Price": item.Price || "",
    "Remarks": item.Remarks || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Items");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(data, "items_list.xlsx");
};
const handleLogout = () => {
  localStorage.removeItem("currentUser");
  window.location.href = "/"; // go back to login page
};

  return (
    <div style={styles.container}>
    <div style={styles.tableSection}>
    <div style={styles.topBar}>
    <h2 style={styles.heading}>Items Pricing List</h2>
    <div style={styles.rightControls}>
    <div style={styles.rightControls}>
    <button style={styles.logoutButton} onClick={handleLogout}>
    Logout
    </button>
    </div>
    </div>
    </div>
  {/* PDF Download */}
    <div style={styles.actionBar}>
    <button style={styles.pdfButton} onClick={downloadExcel}>
    Download File
    </button>

   <input
    type="date"
    value={selectedDate}
    onChange={(e) => setSelectedDate(e.target.value)}
    style={styles.dateInput}
   />
   </div>
    {/* Table Grid */}
    <div style={styles.tableWrapper}>
    {/* Header */}
    <div style={styles.gridHeaderRow}>
    {["S.No", "Item Name", "Unit", "Price", "Remarks"].map((h, i) => (
    <div key={i} style={styles.gridCell}>
    {h}
    </div>
    ))}
    </div>
    {/* Rows */}
    {items.length === 0 ? (
    <div style={styles.noData}>No items available</div>
    ) : (
    items.map((item, index) => (
    <div
    key={index}
    style={index % 2 === 0 ? styles.gridRowEven : styles.gridRowOdd}
    >
    <div style={styles.gridCell}>{index + 1}</div>
    <div style={styles.gridCell}>{item.ItemName}</div>
    <div style={styles.gridCell}>{item.Unit}</div>
    <div style={styles.gridCell}>{item.Price}</div>
    <div style={styles.gridCell}>{item.Remarks}</div>
    </div>
    ))
    )}
    </div>
    </div>
    </div>
  );
}

const styles = {
  container: {
  padding: "0",
  background: "#f1f5f9",
  minHeight: "100vh",
},

  tableSection: {
    background: "#ffffff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
  },

  heading: {
    marginBottom: "20px",
    color: "#0f172a",
    fontSize: "24px",
    fontWeight: "600",
  },

  pdfButton: {
    marginBottom: "20px",
    padding: "10px 18px",
    background: "#0a7c3b",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "500",
  },

  actionBar: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "15px",
},

dateInput: {
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid #cbd5e1",
  fontSize: "14px",
  background: "#fff",
  cursor: "pointer",
},

  dateWrapper: {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  marginBottom: "15px",
},

dateLabel: {
  fontWeight: "500",
  color: "#334155",
},

dateInput: {
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid #cbd5e1",
  fontSize: "14px",
  cursor: "pointer",
},

  tableWrapper: {
    overflowX: "auto",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
  },

  gridHeaderRow: {
    display: "grid",
    gridTemplateColumns: "60px 2fr 1fr 1fr 2fr",
    padding: "14px 16px",
    background: "#0f172a",
    color: "#ffffff",
    fontWeight: "600",
    fontSize: "14px",
  },

  gridRowEven: {
    display: "grid",
    gridTemplateColumns: "60px 2fr 1fr 1fr 2fr",
    padding: "12px 16px",
    borderTop: "1px solid #e2e8f0",
    background: "#ffffff",
    alignItems: "center",
    fontSize: "14px",
  },

  gridRowOdd: {
    display: "grid",
    gridTemplateColumns: "60px 2fr 1fr 1fr 2fr",
    padding: "12px 16px",
    borderTop: "1px solid #e2e8f0",
    background: "#f8fafc",
    alignItems: "center",
    fontSize: "14px",
  },

  gridCell: {
    overflowWrap: "break-word",
  },

  topBar: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
},

rightControls: {
  display: "flex",
  alignItems: "center",
  gap: "15px",
},

heading: {
  margin: 0,   // important: remove bottom margin
  color: "#1e293b",
  fontSize: "22px",
  fontWeight: "600",
},

dateInput: {
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid #cbd5e1",
  fontSize: "14px",
  background: "#fff",
  cursor: "pointer",
},

logoutButton: {
  padding: "8px 16px",
  background: "#dc2626",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "500",
},

  noData: {
    padding: "30px",
    textAlign: "center",
    color: "#64748b",
  },
};


